import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./BaggageFreeTag.scss";
import { BaggageLFilledIcon } from "app/icons/travel";

const BaggageFreeTag = () => {
	return (
		<div className="baggage-free-tag" data-testid="baggage-free-tag">
			<BaggageLFilledIcon data-testid="icon-check-luggage" />
			<Typography
				variant={TYPOGRAPHY_VARIANTS.SMALL}
				isBold
				className="baggage-free-tag__label"
			>
				<FormattedMessage id="product.baggage.free.tag" />
			</Typography>
		</div>
	);
};

export default memo(BaggageFreeTag);
